interface UserAgentData {
  brands: { brand: string; version: string }[];
  mobile: boolean;
}

export const isEdge = () => {
  if ("userAgentData" in window.navigator) {
    const userAgentData = window.navigator.userAgentData as UserAgentData;
    return userAgentData.brands.some((brand) =>
      brand.brand.toLowerCase().includes("edge")
    );
  }

  return window.navigator.userAgent.toLowerCase().includes("edg");
};

export const isChrome = () => {
  if ("userAgentData" in window.navigator) {
    const userAgentData = window.navigator.userAgentData as UserAgentData;
    return userAgentData.brands.some((brand) =>
      brand.brand.toLowerCase().includes("chrome")
    );
  }

  return (
    !isEdge() && window.navigator.userAgent.toLowerCase().includes("chrome")
  );
};

export const isRssSupportedBrowser = () => isEdge() || isChrome();

export const isRssInstalled = () =>
  Boolean(document.documentElement.getAttribute("rss-ext-installed"));

export const getBrowserName = () => {
  if (isEdge()) return "Edge";
  if (isChrome()) return "Chrome";

  return null;
};
